import { stringify } from 'qs';

import { setQueryParams } from './queryParamsAction';
import { selectPageType, selectQueryParams } from '../../selectors';
import { TQueryParams } from '../../types/page/pageType';
import { TThunkAction } from '../../types/redux';
import { isBrowser } from '../../utils/isBrowser';

export const updateQueryString = (): TThunkAction => (dispatch, getState) => {
  const state = getState();

  const pageType = selectPageType(state);
  const queryParams = selectQueryParams(state);

  const query = {
    ...queryParams,
    dealtype: pageType,
  } as TQueryParams;

  dispatch(setQueryParams(query));

  if (isBrowser()) {
    const { protocol, host, pathname } = window.location;

    const queryString = stringify(query, { addQueryPrefix: true, skipNulls: true });

    const url = `${protocol}//${host}${pathname}${queryString}`;

    window.history.pushState('', 'Онлайн аренда', url);
  }
};
